import React from 'react';

const DragHandle = () => {
  return (
    <div
      style={{
        width: 26,
        position: 'absolute',
        left: '50%',
        zIndex: 100,
        top: 8,
        height: 5,
        background: '#ddd',
        borderRadius: '50px'
      }}
    />
  );
};

export default DragHandle;
